var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgProviderCmdb(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "65px",
    height: "65px",
    viewBox: "0 0 65 65",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Servicenow") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Servicenow",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16,0 L49,0 C57.836556,0 65,7.163444 65,16 L65,49 C65,57.836556 57.836556,65 49,65 L16,65 C7.163444,65 0,57.836556 0,49 L0,16 C0,7.163444 7.163444,0 16,0 Z",
    id: "Background",
    fill: "#F9F9F9",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49,0.5 C53.2802068,0.5 57.1552068,2.23489659 59.9601551,5.03984489 C62.7651034,7.84479319 64.5,11.7197932 64.5,16 L64.5,49 C64.5,53.2802068 62.7651034,57.1552068 59.9601551,59.9601551 C57.1552068,62.7651034 53.2802068,64.5 49,64.5 L16,64.5 C11.7197932,64.5 7.84479319,62.7651034 5.03984489,59.9601551 C2.23489659,57.1552068 0.5,53.2802068 0.5,49 L0.5,16 C0.5,11.7197932 2.23489659,7.84479319 5.03984489,5.03984489 C7.84479319,2.23489659 11.7197932,0.5 16,0.5 Z",
    id: "Border",
    stroke: "#D8D8D8",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.9995014,44.6162044 C26.7667103,44.6162044 22.5001047,39.9232793 22.5001047,34.118513 C22.5001047,28.3103361 26.7667103,23.5389682 32.9995014,23.5389682 C39.2357031,23.5389682 43.4988981,28.3103361 43.4988981,34.118513 C43.4988981,39.9232793 39.2357031,44.6162044 32.9995014,44.6162044 M33.1222814,13 C21.6150654,12.9338443 12.0979089,22.3486842 12.0007081,33.9002374 C11.951255,40.013659 14.4955298,45.5353492 18.5967234,49.4165619 C20.0888416,50.8268268 22.3943775,50.9649544 24.010981,49.7013434 C26.4017808,47.8357692 29.4712812,46.723928 32.9995014,46.723928 C36.5277216,46.723928 39.597222,47.8357692 41.9880217,49.7013434 C43.6199728,50.975186 45.934035,50.8114793 47.4346797,49.3858669 C51.4761886,45.5438756 54,40.105744 54,34.0775863 C54,22.4782853 44.6618977,13.066856 33.1222814,13",
    id: "Fill-11",
    fill: "#6DB851"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProviderCmdb);
export default __webpack_public_path__ + "static/media/provider-cmdb.8231e81471b5f85cfa3cf25a924de2c3.svg";
export { ForwardRef as ReactComponent };